import React, { useState } from "react";
import { FaPlusSquare, FaAngleRight, FaArrowLeft } from "react-icons/fa";
import "./UserProfile.css";
import "./Orders.css";
import { Scroll } from "../Scroll function/scroll";
import { AiOutlineRight } from "react-icons/ai";
import credit from "./Assets/credit-card.svg";
import creditGray from "./Assets/credit-card(gray).svg";
import order from "./Assets/order.svg";
import orderGray from "./Assets/order(gray).svg";
import NewHeader from "../NewHeader/NewHeader";
import address from "./Assets/address.svg";
import addressPink from "./Assets/location.svg";
import wallet from "./Assets/redwallet.svg";
import walletInactive from "./Assets/wallet-inactive.svg";
import help from "./Assets/help.svg";
import helpgray from "./Assets/help(gray).svg";
import { BackToscreen } from "./Orders";
import { Link } from "react-router-dom";
import {
  getCustomerDashboard,
  EditForm,
  setCity,
  setLogout,
} from "../../Redux/Actions";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import Loader from "../Loader/Loader";
import Footer from "../Footer/Footer";
import profileImage from "./Assets/profileImage.jpg";
import { RiLogoutBoxLine } from "react-icons/ri";
import { useHistory } from "react-router-dom";
export const ToggleMenu = ({
  isOrder,
  isUserprofile,
  isLoginfun,
  isGroupAndFamily,
  isMyAddresses,
  isMyPrescription,
  isMyRedCash,
  isHelpAndSupport,
  isLogin,
  setCartLength,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const customerDetails = useSelector((state) => state.customerDashboard);
  const { packages, loading } = customerDetails;

  const userRedcashValue = packages?.profile?.redcash;
  const allData = packages && packages.profile;

  useEffect(() => {
    if (localStorage.getItem("user")) {
      console.log("userPresent");
      const datekey = JSON.parse(localStorage.getItem("user"));
      const token = datekey && datekey?.token;
      token !== undefined && token !== ""
        ? dispatch(getCustomerDashboard(token))
        : null;
    } else {
      console.log("no user");
    }
  }, []);

  const [login, setlogin] = useState(false);

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    if (userDetails && userDetails.token) {
      setlogin(true);
      isLoginfun && isLoginfun(true);
    } else {
      setlogin(false);
      isLoginfun && isLoginfun(false);
    }
  }, [login]);

  //SIGN OUT USER
  const signOutUser = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("city");
    localStorage.removeItem("localslug");
    localStorage.setItem("MyBookings", JSON.stringify([]));
    dispatch(setCity(""));
    dispatch({
      type: "LOGIN_OTP_RESPONSE_CLEAR",
    });
    dispatch({
      type: "LOGOUT_SUCCESS"
    });
    // setCartLength(0)
    // history.push("/");
    window.location.href = process.env.RAZZLE_APP_BASE_URL;
    setlogin(false);
    setTimeout(() => {
      dispatch(setLogout(true));
    }, 400);
    isLoginfun && isLoginfun(false);
  };
  return (
    <div className="left_menu">
      <h2>
        Hi,{" "}
        {loading
          ? "loading"
          : login
            ? allData?.fullname
              ? allData?.fullname
              : "Guest"
            : "Guest"}
        {login ? (
          ""
        ) : (
          <a href={process.env.RAZZLE_APP_BASE_URL}
            // to={{
            //   pathname: `/login`,
            // }}
            className="loginUser"
          >
            LogIn
          </a>
        )}
      </h2>
      <span className="choose_option deadState">
        <img src={isUserprofile ? credit : creditGray} />
        <a
          href={
            login
              ? `${process.env.RAZZLE_APP_BASE_URL}/dashboard/userprofile/`
              :  process.env.RAZZLE_APP_BASE_URL
          }
          style={isUserprofile ? { color: "#0e3f6c", fontWeight: "600" } : null}
        >
          Personal Information <AiOutlineRight />
        </a>

        {/* <Link
          to={{
            pathname: login ? "/userprofile" : "/login",
            pushToUrl: "userprofile",
          }}
          style={isUserprofile ? { color: "#0e3f6c", fontWeight: "600" } : null}
        >
          Personal Information <AiOutlineRight />
        </Link> */}
      </span>

      <span className="choose_option deadState">
        <img src={isOrder ? order : orderGray} />
        <a
          href={
            login
              ? `${process.env.RAZZLE_APP_BASE_URL}/dashboard/myOrders/`
              : process.env.RAZZLE_APP_BASE_URL
          }
          style={isUserprofile ? { color: "#0e3f6c", fontWeight: "600" } : null}
        >
          My Orders <AiOutlineRight />
        </a>
        {/* <Link
          to={{
            pathname: login ? "/myOrders" : "/login",
            pushToUrl: "myOrders",
          }}
          style={isOrder ? { color: "#0e3f6c", fontWeight: "600" } : null}
        >
          My Orders <AiOutlineRight />
        </Link> */}
      </span>
      {/* <span className="choose_option">
        <img src={isGroupAndFamily ? group : groupAndFamily} />
        <Link
          to="/familyfriends"
          style={
            isGroupAndFamily ? { color: "#0e3f6c", fontWeight: "600" } : null
          }
        >
          My Family & Friends <AiOutlineRight />
        </Link>
      </span> */}
      <span className="choose_option deadState">
        <img src={isMyAddresses ? addressPink : address} />
        <a
          href={
            login
              ? `${process.env.RAZZLE_APP_BASE_URL}/dashboard/myaddresses/`
              : process.env.RAZZLE_APP_BASE_URL
          }
          style={isUserprofile ? { color: "#0e3f6c", fontWeight: "600" } : null}
        >
          My Addresses  <AiOutlineRight />
        </a>
        {/* <Link
          to={{
            pathname: login ? "/myaddresses" : "/login",
            pushToUrl: "myaddresses",
          }}
          style={isMyAddresses ? { color: "#0e3f6c", fontWeight: "600" } : null}
        >
          My Addresses <AiOutlineRight />
        </Link> */}
      </span>
      <span className="choose_option deadState">
        <img src={isMyPrescription ? "https://staticcdn.redcliffelabs.com/media/gallary-file/None/73216124-2de8-44ae-ae1d-504d14b414be.svg" : "https://staticcdn.redcliffelabs.com/media/gallary-file/None/4297086b-df5a-4255-992e-382ca888b702.svg"} />
        <a
          href={
            login
              ? `${process.env.RAZZLE_APP_BASE_URL}/dashboard/prescription/`
              : process.env.RAZZLE_APP_BASE_URL
          }
          style={isUserprofile ? { color: "#0e3f6c", fontWeight: "600" } : null}
        >
          My Prescription <AiOutlineRight />
        </a>
        {/* <Link
          to={{
            pathname: login ? "/myprescription" : "/login",
            pushToUrl: "myprescription",
          }}
          style={isMyPrescription ? { color: "#0e3f6c", fontWeight: "600" } : null}
        >
          My Prescription <AiOutlineRight />
        </Link> */}
      </span>
      <span className="choose_option deadState">
        <img src={isMyRedCash ? wallet : walletInactive} />
        <a
          href={
            login
              ? `${process.env.RAZZLE_APP_BASE_URL}/dashboard/myredcash/`
              : process.env.RAZZLE_APP_BASE_URL
          }
          style={isUserprofile ? { color: "#0e3f6c", fontWeight: "600" } : null}
        >
          My Redcash <AiOutlineRight />
        </a>

        {/* <Link
          to={
            login
              ? {
                pathname: "/myredcash",
                state: { userRedcashValue: userRedcashValue },
              }
              : {
                pathname: "/login",
                pushToUrl: "myredcash",
                state: { userRedcashValue: userRedcashValue },
              }
          }
          style={isMyRedCash ? { color: "#0e3f6c", fontWeight: "600" } : null}
        >
          My Redcash <AiOutlineRight />
        </Link> */}
      </span>
      <span className="choose_option deadState">
        <img src={isHelpAndSupport ? help : helpgray} />{" "}
        <a
          href={
            login
              ? `${process.env.RAZZLE_APP_BASE_URL}/dashboard/helpandsupport/`
              : process.env.RAZZLE_APP_BASE_URL
          }
          style={isUserprofile ? { color: "#0e3f6c", fontWeight: "600" } : null}
        >
          Help & support <AiOutlineRight />
        </a>
        {/* <Link
          to={{
            pathname: login ? "/helpandsupport" : "/login",
            pushToUrl: "helpandsupport",
          }}
          style={
            isHelpAndSupport ? { color: "#0e3f6c", fontWeight: "600" } : null
          }
        >
          Help & support <AiOutlineRight />
        </Link> */}
      </span>
      {login ? (
        <span
          style={{ borderBottom: "none" }}
          className="choose_option deadState"
        >
          <RiLogoutBoxLine
            style={{ marginRight: "1rem", fontSize: "2.5rem" }}
          />

          <a href={process.env.RAZZLE_APP_BASE_URL}>
            Log Out <AiOutlineRight />
          </a>
          {/* <a href={process.env.RAZZLE_APP_BASE_URL} onClick={signOutUser}>
            Log Out <AiOutlineRight />
          </a> */}
        </span>
      ) : null}
    </div>
  );
};

const Dashboard = () => {
  const [login, setlogin] = useState(false);
  const [editDetails, setEditDetails] = useState(false);
  const [fullname, setFullname] = useState("");
  const [fullNameError, setFullNameError] = useState("");
  const [age, setAge] = useState("");
  const [ageError, setAgeError] = useState("");
  const [email, setEmail] = useState("");
  const [emailEroor, setEmailError] = useState("");
  const [address, setAddress] = useState("");
  const [gender, setGender] = useState("");

  const [base64Image, setbase64Image] = useState("");

  const dispatch = useDispatch();
  const customerDetails = useSelector((state) => state.customerDashboard); // this pick the state and reducer function

  // console.log("CT", customerDetails);
  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    if (userDetails && userDetails.token) {
      setlogin(true);
    } else {
      setlogin(false);
    }
  }, []);

  const { packages, loading } = customerDetails;

  // if (loading) {
  //   console.log("LOADING");
  // } else {
  //   console.log("DETAILS", packages.profile);
  // }

  const allData = packages.profile;

  // console.log("CT", customerDetails);

  const handleEdit = () => {
    setEditDetails(true);
    sendId(allData);
  };

  const handelSave = (e) => {
    e.preventDefault();
    const datekey = JSON.parse(localStorage.getItem("user"));
    const token = datekey.token;
    const phonenumber = datekey.username;

    // console.log(phonenumber, "phone no");

    const body = {
      fullname,
      age,
      email,
      address,
      gender,
      image: base64Image ? base64Image : null,
    };
    // console.log("BODY", body);

    const successCb = () => {
      dispatch(getCustomerDashboard(token));
    };

    dispatch(EditForm(token, body, phonenumber, successCb));
    setEditDetails(false);
  };

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  const uploadImage = (e) => {
    // console.log(e.target.files[0]);
    var file = e.target.files[0];

    const filePath = e.target.value;
    console.log("filepath", filePath);

    getBase64(file).then((data) => {
      setbase64Image(data);
    });
  };

  useEffect(() => {
    const datakey = JSON.parse(localStorage.getItem("user"));
    if (!datakey) {
      window.location.href = process.env.RAZZLE_APP_BASE_URL;
      // history.push({
      //   pathname: `/login`,
      //   pushToUrl: "userprofile",
      // });
    }
  }, []);

  const sendId = (values) => {
    // console.log("VALUES", values);

    setFullname(values.fullname);
    setAddress(values.address);
    setEmail(values.email);
    setAge(values.age);
    setGender(values.gender);
  };

  const handelUserName = (e) => {
    setFullname(e.target.value);
    const characterRegex = /^[( )a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z-( )]*)*$/;
    setFullNameError("");
    if (!e.target.value.match(characterRegex)) {
      setFullNameError("invalid user name");
    }
    if (e.target.value == "") {
      setFullNameError("");
    }
  };

  const handelEmail = (e) => {
    setEmail(e.target.value);
    const characterRegex = /^\S+@\S+\.\S+$/;
    setEmailError("");
    if (!e.target.value.match(characterRegex)) {
      setEmailError("invalid email");
    }
    if (e.target.value == "") {
      setEmailError("");
    }
  };

  const handelAge = (e) => {
    setAge(e.target.value);
    const characterRegex = /^100|[1-9]?\d$/;
    setAgeError("");
    if (!e.target.value.match(characterRegex)) {
      setAgeError("Enter a valid age");
    }
    if (e.target.value == "") {
      setAgeError("");
    }
  };
  // console.log(">>>>>>>>>>", allData?.image)

  useEffect(() => {
    Scroll();
    const datekey = JSON.parse(localStorage.getItem("user"));
    // console.log("DATEKEY", datekey.token)

    dispatch(getCustomerDashboard(datekey.token));
  }, [base64Image]);

  return (
    <div>
      <NewHeader />
      <div className="activeDashboard">
        <div className="dashboard_content">
          <div className="back_btn"></div>
          <BackToscreen title="User Profile" />
          <div className="fleex_rows">
            <div className="dashboard_contentLeft">
              <ToggleMenu isUserprofile={true} isLogin={login} />
            </div>

            <div className="dashboard_contentRight dashboard_contentRight2 userProfileContentHeight">
              {!editDetails ? (
                <div className="userPreview">
                  {loading ? (
                    <Loader />
                  ) : (
                    <>
                      <div className="right_menu_header">
                        <div className="image">
                          <img
                            src={allData?.image ? allData?.image : profileImage}
                          />
                          {/* <FaPlusSquare /> */}
                        </div>

                        <button onClick={handleEdit}>Edit</button>
                      </div>

                      {/* MOBILE VIEW */}
                      <div className="image_mobile">
                        <img
                          src={allData?.image ? allData?.image : profileImage}
                        />
                        {/* <FaPlusSquare /> */}
                      </div>

                      <div className="person_details1 person_detailsHeight1">
                        <div className="person_info">
                          <p className="top">NAME</p>
                          <p className="bottom">{allData?.fullname}</p>
                        </div>
                        {/* <div className="person_info">
                          <p className="top">USER NAME</p>
                          <p className="bottom">{allData?.username}</p>
                        </div> */}
                        <div className="person_info">
                          <p className="top">ADDRESS</p>
                          <p className="bottom">{allData?.address}</p>
                        </div>

                        <div className="person_info">
                          <p className="top">EMAIL</p>
                          <p className="bottom">{allData?.email}</p>
                        </div>
                        <div className="person_info">
                          <p className="top">AGE</p>
                          <p className="bottom">{allData?.age}</p>
                        </div>
                        <div className="person_info">
                          <p className="top">GENDER</p>
                          <p className="bottom">{allData?.gender}</p>
                        </div>
                        <div className="person_info">
                          <p className="top">MOBILE</p>
                          <p className="bottom">{allData?.phonenumber}</p>
                        </div>
                      </div>
                      <div className="edit_info_mobile">
                        <button onClick={handleEdit}>Edit Info</button>
                      </div>
                    </>
                  )}
                </div>
              ) : (
                <div className="userPreview">
                  <div className="right_menu_header">
                    <label htmlFor="file_upload">
                      <div className="image">
                        <img
                          src={
                            base64Image && base64Image !== ""
                              ? base64Image
                              : allData?.image
                                ? allData?.image
                                : profileImage
                          }
                          alt="profile img"
                        />

                        <input
                          type="file"
                          id="file_upload"
                          // onChange={(e) => {
                          //   uploadImage(e)
                          // }}
                          onChange={uploadImage}
                          accept="image/png, image/jpeg"
                        />

                        <FaPlusSquare />
                      </div>
                    </label>

                    <div className="headerBtn">
                      <button
                        className="cancelBtn"
                        onClick={() => setEditDetails(false)}
                      >
                        Cancel
                      </button>
                      <button
                        className="saveBtn"
                        disabled={
                          fullNameError !== "" ||
                          ageError !== "" ||
                          emailEroor !== ""
                        }
                        onClick={handelSave}
                      >
                        Save
                      </button>
                    </div>
                  </div>

                  {/* MOBILE VIEW OF UPLOAD IMAGE */}
                  <label htmlFor="file_upload_mobile">
                    <div className="image_mobile">
                      <img
                        src={base64Image ? base64Image : allData?.image}
                        alt="profile img"
                      />

                      <input
                        type="file"
                        id="file_upload_mobile"
                        // onChange={(e) => {
                        //   uploadImage(e)
                        // }}
                        onChange={uploadImage}
                        accept="image/png, image/jpeg"
                      />

                      <FaPlusSquare />
                    </div>
                  </label>

                  <div className="person_details_edit">
                    <div className="person_info">
                      <p className="top">Name</p>
                      <input
                        type="text"
                        value={fullname}
                        placeholder="Name"
                        onChange={handelUserName}
                      />
                      <span id="errorMessage">{fullNameError}</span>
                    </div>

                    {/* <div className="person_info">
                      <p className="top">Last name</p>
                      <input type="text"  />
                    </div> */}

                    <div className="person_info">
                      <p className="top">Address</p>
                      <input
                        type="text"
                        value={address}
                        placeholder="Address"
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </div>

                    <div className="person_info">
                      <p className="top">Email</p>
                      <input
                        type="email"
                        value={email}
                        placeholder="Email"
                        onChange={handelEmail}
                      />{" "}
                      <br></br>
                      <span id="errorMessage">{emailEroor}</span>
                    </div>

                    <div className="person_info">
                      <p className="top">Age</p>
                      <input
                        type="text"
                        placeholder="Age"
                        value={age}
                        onChange={handelAge}
                      />{" "}
                      <br></br>
                      <span id="errorMessage">{ageError}</span>
                    </div>

                    <div className="person_info">
                      <p className="top">Gender</p>
                      <select
                        name=""
                        id=""
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                        defaultValue="Male"
                      >
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                    </div>
                  </div>
                  <div className="save_edit_mobile">
                    <button id="cancel" onClick={() => setEditDetails(false)}>
                      Cancel
                    </button>
                    <button
                      id="save"
                      disabled={fullNameError !== "" && emailEroor !== ""}
                      onClick={handelSave}
                    >
                      Save
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default {
  component: Dashboard,
};
